export default "__VITE_ASSET__Cehgwt$R__"